"use client"

import { useState, useEffect } from "react"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"
import { getFirestore, collection, onSnapshot } from "firebase/firestore"
import MKBox from "components/MKBox"
import MKTypography from "components/MKTypography"
import CircularProgress from "@mui/material/CircularProgress"
import Project from "./Project"
import { motion } from "framer-motion"

const ProjectsList = () => {
  const [projects, setProjects] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const db = getFirestore()

  useEffect(() => {
    const collectionRef = collection(db, "pastProjects")
    const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
      const tempProjects = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      const cleaned = tempProjects.filter((project) => project.id !== "Metadata")
      setProjects(cleaned)
      setIsLoading(false)
    })

    return () => unsubscribe()
  }, [db])

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    },
  }

  return (
    <MKBox py={4}>
      <Container>
        {isLoading ? (
          <Grid container justifyContent="center" alignItems="center" py={8}>
            <CircularProgress
              sx={{
                color: "#3b82f6",
              }}
            />
          </Grid>
        ) : projects.length === 0 ? (
          <MKTypography variant="h6" textAlign="center" color="#9ca3af" py={8}>
            No projects available at the moment.
          </MKTypography>
        ) : (
          <Grid
            container
            spacing={6}
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {projects.map((project, index) => (
              <Grid
                item
                xs={12}
                key={project.id}
                component={motion.div}
                variants={itemVariants}
              >
                <Project Project={project} reverse={index % 2 !== 0} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </MKBox>
  )
}

export default ProjectsList
